// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"style_tooltip__3QyG6","tooltipText":"style_tooltipText__2H6RP"};